import { MenuEntry } from '@src/menu-entry';
import FillPickingCartMenu from '@src/fill-picking-cart/menu.js';
import EmptyOutPickingCartMenu from '@src/empty-out-picking-cart/menu.js';
import BinFillMenuEntries from '@src/bin-fill/menu.ts';
import BinMenuEntries from '@src/bin/menu';

export default [
    MenuEntry.create()
        .setRoute('stock_transfer'),
    MenuEntry.create()
        .setRoute('warehouse_emons_stock_difference'),
    MenuEntry.create()
        .setRoute('print_product_label'),
    MenuEntry.create()
        .setRoute('bin_labels'),
    MenuEntry.create()
        .setTitle('Lagerfach')
        .setChildren([
            ...BinMenuEntries,
            MenuEntry.create()
                .setRoute('detail_bin_report'),
            ...BinFillMenuEntries,
        ]),
    MenuEntry.create()
        .setRoute('cluster_list')
        .setAdditionalRoutes([
            'cluster_edit',
        ]),
    MenuEntry.create()
        .setRoute('racks_without_cluster_list'),
    MenuEntry.create()
        .setRoute('stock_exit_serial'),
    MenuEntry.create()
        .setRoute('stock_exit_nuk'),
    MenuEntry.create()
        .setRoute('serial_to_nuk'),
    MenuEntry.create()
        .setRoute('warehouse_group_list')
        .setAdditionalRoutes([
            'warehouse_group_detail',
        ]),
    FillPickingCartMenu,
    EmptyOutPickingCartMenu,
    MenuEntry.create()
        .setTitle('Umlagerungsaufträge')
        .setChildren([
            MenuEntry.create()
                .setTitle('Umlagerungsauftrag anlegen')
                .setRoute('transfer_request_create_transfer_request'),
            MenuEntry.create()
                .setTitle('Offene Umlagerungsaufträge')
                .setRoute('transfer_request_list_open')
                .setAdditionalRoutes([
                    'transfer_request_detail',
                ]),
            MenuEntry.create()
                .setTitle('Umlagerungsaufträge suchen')
                .setRoute('transfer_request_search')
                .setAdditionalRoutes([
                    'transfer_request_detail',
                ]),
        ]),
    MenuEntry.create()
        .setTitle('Meldebestände')
        .setRoute('reorder_point_list'),
];
